/**
 * The id of a query within a session: `<route>:<params as canonical JSON>`.
 *
 * Canonical means object keys sorted by code point, no insignificant
 * whitespace, and `undefined` members omitted, so two consumers asking the
 * same question produce the same id and share one server subscription.
 */
export function queryId(route: string, params: Record<string, unknown>): string {
  return `${route}:${canonicalJson(params)}`
}

function canonicalJson(value: unknown): string {
  if (Array.isArray(value)) {
    return `[${value.map(canonicalJson).join(',')}]`
  }
  if (typeof value == 'object' && value != null) {
    const entries = Object.entries(value)
      .filter(([, v]) => v !== undefined)
      .sort(([a], [b]) => (a < b ? -1 : a > b ? 1 : 0))
      .map(([k, v]) => `${JSON.stringify(k)}:${canonicalJson(v)}`)
    return `{${entries.join(',')}}`
  }
  return JSON.stringify(value)
}
